export const NETWORK_ERROR_CODE = 1002;
export const NETWORK_ERROR_CATEGORY = 1;
export const CONCURRENCY_ERROR_CODE = 403;
export const STREAM_LIMIT_REACHED = 409;
export const PLAYER_ERROR_INTERRUPT = 7000;
export const INACTIVE_DEVICE = 'INACTIVE_DEVICE';
export const STREAM_LIMIT = 'STREAM_LIMIT';
export const STREAM_REPLACED = 'STREAM_REPLACED';
export const CONTENT_UNAVAILABLE = 'CONTENT_UNAVAILABLE';
export const DRM_GW_TOO_MANY_DEVICES = 'TOO_MANY_DEVICES';
export const DRM_GW_TOO_MANY_REGISTRATIONS = 'TOO_MANY_REGISTRATIONS';
export const DRM_GW_UNKNOWN_ERROR = 'UNKNOWN_ERROR';

export const STREAM_ERRORS = [
    DRM_GW_TOO_MANY_DEVICES,
    DRM_GW_TOO_MANY_REGISTRATIONS,
    DRM_GW_UNKNOWN_ERROR,
    STREAM_LIMIT,
    STREAM_REPLACED,
    INACTIVE_DEVICE,
];

interface playerErrors {
    [key: number]: string;
}

// Our internal errors

export const playerErrorsCode: playerErrors = {
    403: 'ERR_DEVICES_LIMIT_REACHED',
    1002: 'ERR_NO_INTERNET_TITLE',
};

// Category errors from the Shaka Player.
// For details please visit https://shaka-player-demo.appspot.com/docs/api/shaka.util.Error.html

export const playerErrorsCategory: playerErrors = {
    1: 'ERR_CATEGORY_NETWORK',
    2: 'ERR_CATEGORY_TEXT',
    3: 'ERR_CATEGORY_MEDIA',
    4: 'ERR_CATEGORY_MANIFEST',
    5: 'ERR_CATEGORY_STREAMING',
    6: 'ERR_CATEGORY_DRM',
    7: 'ERR_CATEGORY_PLAYER',
    8: 'ERR_CATEGORY_CAST',
    9: 'ERR_CATEGORY_STORAGE',
    10: 'ERR_CATEGORY_ADS',
};

export const STREAM_SESSION_ID = 'el-str-id';
export const STREAM_SESSION_HEARTBEAT = 'el-str-hb';

export const VISUALLY_IMPAIRED_ROLES = ['description', 'commentary', 'dub'];
export const HEARING_IMPAIRED_ROLES = ['caption'];

export const STREAMING_FAILURE_MAX_RETRIES = 6;

// End-of-stream watchdog because Safari's native HLS never fires 'ended' past the seek range.
export const PROGRESS_CHECK_INTERVAL_MS = 1000;
export const MIN_MOVEMENT_SECONDS = 0.01;
export const SEEK_END_TOLERANCE = 2;
export const FROZEN_AT_END_MS = 3000;
export const MANIFEST_STATIC_MS = 6000;
export const FROZEN_MID_STREAM_MS = 20000;

export const DOWNLOADS_STALLED_MS = 20000;
export const RECOVERY_KICK_GRACE_MS = 5000;
export const STREAMING_RETRY_GRACE_MS = 20000;
export const STARVED_RETRY_GRACE_MS = 5000;
export const STARVED_SILENCE_MS = 2000;
export const STARVED_KICK_GRACE_MS = 2000;
export const STARVED_BUFFER_SECONDS = 1;
export const STREAM_RELOAD_MAX_ATTEMPTS = 3;
export const STREAM_RELOAD_MIN_GAP_MS = 15000;
export const STREAM_RELOAD_COOLDOWN_MS = 60000;

export const QUOTA_EXCEEDED_ERROR_CODE = 3017;
export const VIDEO_ERROR_CODE = 3016;
export const RECOVERABLE_MEDIA_ERROR_CODES = [VIDEO_ERROR_CODE, QUOTA_EXCEEDED_ERROR_CODE];

export const STARTUP_REBUFFERING_GOAL_SECONDS = 2;
export const LIVE_EDGE_START_OFFSET_SECONDS = 10;

export const MANIFEST_UPDATE_PERIOD_SECONDS = 3;
export const STREAMING_RETRY_PARAMETERS = {
    maxAttempts: 5,
    baseDelay: 1000,
    backoffFactor: 2,
    connectionTimeout: 10000,
    stallTimeout: 5000,
};

export const BANDWIDTH_RATIO_FAST = 2;
export const BANDWIDTH_RATIO_MARGINAL = 1.25;
export const BANDWIDTH_RATIO_SMOOTHING = 0.5;
export const BANDWIDTH_SAMPLE_INTERVAL_MS = 10000;

export const STUCK_BUFFERING_MS = 5000;
export const STUCK_BUFFERING_MAX_MS = 15000;
export const STUCK_SEEK_MS = 15000;
export const FORCED_RELOAD_AFTER_MS = 30000;
export const GAP_PADDING_SECONDS = 0.02;
